exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-wrapper[data-v-1868d790]{position:absolute;top:0;width:100%;height:100%;z-index:1}.loader-wrapper .loader-body[data-v-1868d790]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;left:0;position:absolute;top:0;width:100%}.loader-wrapper .loading[data-v-1868d790]{line-height:1;text-align:center}.loader-wrapper .overlay[data-v-1868d790]{background-color:#fff;opacity:.8;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1868d790","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/box-loader.vue
// module id = rbNe
// module chunks = 86 88